/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SiteCodeRemapResult } from '../models/SiteCodeRemapResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SiteCodeRemapService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns SiteCodeRemapResult OK
     * @throws ApiError
     */
    public postApiHousingSiteCodeRemapPreviewRemap(): CancelablePromise<SiteCodeRemapResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/SiteCodeRemap/PreviewRemap',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns SiteCodeRemapResult OK
     * @throws ApiError
     */
    public postApiHousingSiteCodeRemapExecuteRemap(): CancelablePromise<SiteCodeRemapResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/SiteCodeRemap/ExecuteRemap',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
